import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 760EA0AB-7906-4FA4-86E0-CD18A4073302
 * name skip-forward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-forward.svg
 * tags
 * - Home Automation 
 */
export const SkipForwardIcon = createSvgIcon(<><path d="M4,5V19L11,12M18,5V19H20V5M11,5V19L18,12" /></>, 'SkipForwardIcon');
export default SkipForwardIcon